import common from './common.json';
import globalNavigation from './globalNavigation.json';
import userProfileMenu from './userProfileMenu.json';
import downloadMobileAppModal from './downloadMobileAppModal.json';

export const fr_ca = {
  common,
  globalNavigation,
  userProfileMenu,
  downloadMobileAppModal,
};
